import { BEMBlock } from 'helpers/classnames';
import { type MouseEventHandler } from 'react';
import { useModal } from 'palette/Modal/hooks';
import PromoBar from 'palette/Promobar/Promobar';
import { PromoBar as PromoBarV2 } from 'palette/PromoBarV2';

import '../styles/HeaderTop.scss';

interface PromoBarSelectorProps {
    isV2: boolean;
    uspText: string;
    ariaLabel?: {
        leftArrowButton: string;
        rightArrowButton: string;
    };
    onNextBannerClick: () => void;
    onPreviousBannerClick: () => void;
    setIsPromoBarOpen: (status: boolean) => void;
    onMainLinkClick: MouseEventHandler<HTMLElement>;
    onExpandedLinkClick: MouseEventHandler<HTMLElement>;
}

export function PromoBarSelector({
    isV2,
    uspText,
    ariaLabel,
    onMainLinkClick,
    onNextBannerClick,
    setIsPromoBarOpen,
    onExpandedLinkClick,
    onPreviousBannerClick,
}: PromoBarSelectorProps) {
    const [, BEMElement] = BEMBlock('palette-header-top');
    const { setActiveModalId } = useModal();

    const handlePreviousButtonClick = () => {
        onPreviousBannerClick();
    };

    const handleNextButtonClick = () => {
        onNextBannerClick();
    };

    const handlePromobarOpen = () => {
        setIsPromoBarOpen(true);
        setActiveModalId(null);
    };

    const handlePromobarClose = () => {
        setIsPromoBarOpen(false);
    };

    const handleExpandedLinkClick: MouseEventHandler<HTMLElement> = (event) => {
        onExpandedLinkClick(event);
    };

    const handleMainLinkClick: MouseEventHandler<HTMLElement> = (event) => {
        onMainLinkClick(event);
    };

    if (isV2) {
        return (
            <PromoBarV2
                ariaLabel={ariaLabel}
                onClose={handlePromobarClose}
                onExpandedLinkClick={handleExpandedLinkClick}
                onMainLinkClick={handleMainLinkClick}
                onNextClick={handleNextButtonClick}
                onOpen={handlePromobarOpen}
                onPreviousClick={handlePreviousButtonClick}
            />
        );
    }

    if (!isV2) {
        return (
            <PromoBar
                ariaLabel={ariaLabel}
                onClose={handlePromobarClose}
                onExpandedLinkClick={handleExpandedLinkClick}
                onMainLinkClick={handleMainLinkClick}
                onNextClick={handleNextButtonClick}
                onOpen={handlePromobarOpen}
                onPreviousClick={handlePreviousButtonClick}
            />
        );
    }

    return (
        <div
            className={BEMElement('usp-list')}
            {...uspText && {
                dangerouslySetInnerHTML: { __html: uspText },
            }}
        />
    );
}
